import React from 'react';
import { DownloadIcon, InfinityIcon, LockIcon } from 'lucide-react';
const assurances = [{
  label: 'Téléchargement immédiat',
  Icon: DownloadIcon
}, {
  label: 'Paiement sécurisé',
  Icon: LockIcon
}, {
  label: 'Accès à vie',
  Icon: InfinityIcon
}];
export function AssuranceRow({
  tone = 'light',
  className = ''
}: {
  tone?: 'light' | 'dark';
  className?: string;
}) {
  const text = tone === 'dark' ? 'text-brand-ivory/75' : 'text-brand-charcoal/60';
  const icon = tone === 'dark' ? 'text-brand-butter' : 'text-brand-cta';
  return <ul className={`flex flex-wrap justify-center gap-x-5 gap-y-2 ${className}`} role="list" data-id="element-32" data-mp="2zyum4rd695mk">
      {assurances.map(({
      label,
      Icon
    }) => <li key={label} className={`flex items-center gap-1.5 font-body text-[12px] ${text}`} data-id="element-33" data-mp="39xk5kokpuy4x">
          <Icon className={`h-3.5 w-3.5 ${icon}`} strokeWidth={2.25} aria-hidden="true" data-id="element-34" data-mp="1kim3z1ywnd29" />
          {label}
        </li>)}
    </ul>;
}